import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2'

const NewPassword = () => {
  const navigate = useNavigate();

  const serverHost = process.env.REACT_APP_SERVER_HOST
  
  const location = useLocation();
  const userData = location.state.userData;

  const [password, setPassword] = useState('');
  const [waiting, setWaiting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleProceed = async (event) => {
    event.preventDefault();

    const formData = new FormData();

    formData.append('user_id', userData.user_id);
    
    if (password.length < 6) {
      Swal.fire({
        title: 'Failed to update password',
        text: 'Password should be atleast 6 characters long',
        icon: 'error',
        confirmButtonText: 'Close',
      });
      return;
    }
    formData.append('password', password);
    
    try {
      setWaiting(true);
      const response = await fetch(`${serverHost}/reset-password`, {
        method: 'POST',
        body: formData,
      });
      const result = await response.json();

      if (response.status === 200) {
        sessionStorage.setItem('user_id', result.user_id);
        sessionStorage.setItem('username', result.username);
        sessionStorage.setItem('icon', result.icon);
        localStorage.setItem('ss_token', result.access_token);
        navigate('/dashboard');
      } else {
        Swal.fire({
          title: 'Failed to update password',
          text: result.error,
          icon: 'error',
          confirmButtonText: 'Close'
        });
      }
    } catch (error) {
      Swal.fire({
        title: 'Failed to update password',
        text: error,
        icon: 'error',
        confirmButtonText: 'Close'
      });
    } finally {
      setWaiting(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Container>
      <FormContainer>
        <LabelContainer>
          <Logo src="images/connectkgp.png" alt="connectKGP" />
          <Title>Reset Your Password</Title>
        </LabelContainer>
        <ImageContainer>
          <img src="images/password.png" alt="Password Icon" />
        </ImageContainer>
        <Form id="passwordForm" onSubmit={handleProceed}>
          <InputContainer>
            <InputLabel>New Password</InputLabel>
            <PasswordInputContainer>
              <PasswordInput
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="off"
                required
              />
              <PasswordVisibilityButton onClick={togglePasswordVisibility}>
                {showPassword ? 'Hide' : 'Show'}
              </PasswordVisibilityButton>
            </PasswordInputContainer>
          </InputContainer>
          <ResetButton onClick={handleProceed} disabled={waiting}>{waiting ? <i className='fa fa-spinner' />:'Reset Password'}</ResetButton>
        </Form>
      </FormContainer>
    </Container>
  );
};

export default NewPassword;

const Container = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 92vh;
  background-color: white;
`;

const FormContainer = styled.div`
  margin: auto auto;
  position: relative;
  width: 25%;
  background: rgba(217, 217, 217, 0.5);
  box-shadow: rgba(0, 0, 0, 0.2) -5px 5px 0px;

  @media only screen and (max-width: 600px) {
    width: 90%;
  }
`;

const LabelContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  background: #6559a2;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  justify-content: center;
  align-items: center;
`;

const Logo = styled.img`
  height: 50px;
`;

const Title = styled.p`
  color: white;
  font-size: 20px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: transparent;
  padding-top: 10px;
  text-align: center;
`;

const ImageContainer = styled.div`
  text-align: center;
  background: transparent;
  padding: 0 20px;

  img {
    margin-top: 20%;
    background: transparent;
  }
`;

const InputContainer = styled.div`
  display: flex;
  width: 20vw;
  gap: 20px;
  justify-content: center;
  align-items: center;
`;

const InputLabel = styled.span`
`;

const ResetButton = styled.button`
  margin-top: 50px;
  margin-bottom: 20px;
  padding: 10px 25px;
  background: #6559a2;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  box-shadow: rgba(0, 0, 0, 0.2) -3px 3px 0px;

  &:disabled {
    background: #d9d9d9;
    cursor: default;
    color: #6559a2;
    font-weight: bold;
  }

  i {
    animation: rotation 2s infinite linear;
  }

  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
`;

const PasswordInputContainer = styled.div`
  position: relative;
`;

const PasswordInput = styled.input`
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
`;

const PasswordVisibilityButton = styled.span`
  font-size: 14px;
  font-weight: bold;
  position: absolute;
  top: 30%;
  right: 10px;
  color: #6559a2;
  cursor: pointer;
`;